import Banner from "../components/Portfolio/Banner/Banner";
import Mechanical from "../components/Portfolio/Mechanical/Mechanical";
import Projects from "../components/Portfolio/Projects/Projects";
import Residential from "../components/Portfolio/Residential/Residential";
import WhyChoose from "../components/Portfolio/WhyChoose/WhyChoose";
import HelmetLayout from "../components/GlobalComponents/HelmetLayout";
import Electrical from "../components/Portfolio/Electrical/Electrical";
import Plumbing from "../components/Portfolio/Plumbing/Plumbing";
import Conditioning from "../components/Portfolio/Conditioning/Conditioning";

const Portfolio = () => {
    return (
        <HelmetLayout
            name="Portfolio"
            title="Our Projects | Ard Altaamir Renovation Portfolio"
            description="See Ard Altaamir’s completed renovation and maintenance before/after projects showcasing our commitment to quality, design, and customer satisfaction."
            route="portfolio"
        >
            <Banner />
            <Mechanical />
            <Electrical />
            <Plumbing />
            <Conditioning />
            <Projects />
            <Residential />
            <WhyChoose />
        </HelmetLayout>
    );
};

export default Portfolio;
